export const ResponseErrorMessage: { [k: number]: string } = {
  400: "Bad request",
  401: "Unauthorized, please log in again",
  403: "Access denied",
  404: "Request error, the resource was not found",
  405: "Request method not allowed",
  408: "Request timed out",
  500: "Server error, please try again or refresh the page",
  501: "The network is not implemented",
  502: "Network Error",
  503: "Service is not available",
  504: "Network timeout",
  505: "HTTP version does not support the request",
}
